<script lang="ts">
	import CalendarApp from "./components/CalendarApp.svelte";
	import AdminLogin from "./components/AdminLogin.svelte";
	import AdminPanel from "./components/AdminPanel.svelte";
import OnlyCalendar from "./components/OnlyCalendar.svelte";

	let adminLogin = false;
	let adminPanel = false;
	let retry: boolean = false;
	let promise;
	let loggingin: boolean = false;
	let verified: boolean;
	let username: string;

	const toggleAdminLogin = (e) => {
		adminLogin = e.detail.adminLogin
	}

	const toggleAdminPanel = (e) => {
		username = e.detail.username
		promise = fetchJson(e.detail)
	}

	const logout = () => {
		fetchLogout(username)
	}

	async function fetchLogout(user) {
		if (document.cookie.includes("token=")){
			let res = await fetch("/user/logout", {
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json"
			}
			});
			let data = await res.json()
		}
		adminLogin = false;
		retry = false;
		loggingin = false;
		verified = false;
		username = ""
	}

	async function fetchJson(user) {
		loggingin = true
		let res = await fetch("/user/login", {
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				username: user.username,
				password: user.password
			}),
		});
		let data = await res.json();
		if(data.data.token){
			verified = true
			loggingin = false;
		}else{
			retry = !data.data
		}
	}

	async function verifySession() {
		adminPanel = new URLSearchParams(window.location.search).get("admin") != null
		if(document.cookie.includes("token=")){
			let res = await fetch("/user/verifysession", {
				method: "POST",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json"
				}
			})
			let data = await res.json()
			verified = data.verified
		}else{
			verified = false
		}
		
	}
	let isVerified = verifySession()
</script>
<div>
	{#await isVerified}
	<div></div>
	{:then}
	{#if adminPanel == true}
		{#if verified}
		<AdminPanel on:logout={logout} username={username} on:verifySession={verifySession}/>
		{:else}
			{#if loggingin}
				{#await promise}
					<AdminLogin retry={retry} adminLogin={adminLogin} awaitLogin={true}/>
				{:then}
					<AdminLogin retry={retry} adminLogin={adminLogin} awaitLogin={false} on:toggleAdminLogin={toggleAdminLogin} on:login={toggleAdminPanel}/>
				{/await}
			{:else}
				<AdminLogin retry={retry} adminLogin={adminLogin} awaitLogin={false} on:toggleAdminLogin={toggleAdminLogin} on:login={toggleAdminPanel}/>
			{/if}
			
			{#if !adminLogin}
				<CalendarApp />
			{/if}
		{/if}
	{:else}
	<OnlyCalendar />
	{/if}
	{/await}
</div>